/* import __COLOCATED_TEMPLATE__ from './business-type.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { Validation } from '@banking/ui/utils/validation';
import { inject as service } from '@ember/service';
let BusinessType = (_class = class BusinessType extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "businessType", _descriptor2, this);
    _initializerDefineProperty(this, "validation", _descriptor3, this);
    this.businessType = this.args.businessType;
  }
  validate() {
    this.validation = new Validation();
    if (!this.businessType) {
      this.validation = new Validation(this.intl.t('banking.shared.onboarding.fields.businessType.error'));
    }
  }
  updateBusinessType(event) {
    const newValue = event.detail.newSelection?.value;
    this.businessType = newValue;
    if (this.validation.isInvalid) {
      this.validate();
    }
  }
  submit(event) {
    event.preventDefault();
    this.validate();
    if (this.validation.isInvalid || !this.businessType) {
      return;
    }
    this.args.onSubmit({
      businessType: this.businessType
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "businessType", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "validation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Validation();
  }
}), _applyDecoratedDescriptor(_class.prototype, "updateBusinessType", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateBusinessType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype), _class);
export { BusinessType as default };